import { ApiError } from '@mh-wms/api-client';
import { authedFetch } from '@/shared/api/client';

export type SlipKind = 'stock-in' | 'stock-out';

export interface SlipTemplate {
  title: string;
  brandText: string;
  showBrand: boolean;
  showAvailableQuantity: boolean;
  marginMm: number;
  headingSize: number;
  bodySize: number;
  shadeTableHeader: boolean;
  pickerLabel: string;
  signatureLabel: string;
}

export interface SlipTemplates {
  stockIn: SlipTemplate;
  stockOut: SlipTemplate;
}

export const DEFAULT_SLIP_TEMPLATES: SlipTemplates = {
  stockIn: {
    title: 'Stock In',
    brandText: 'MH GLOBAL',
    showBrand: false,
    showAvailableQuantity: true,
    marginMm: 10,
    headingSize: 22,
    bodySize: 9,
    shadeTableHeader: true,
    pickerLabel: 'Picker Name',
    signatureLabel: 'Sign',
  },
  stockOut: {
    title: 'Stock Out',
    brandText: 'MH GLOBAL',
    showBrand: true,
    showAvailableQuantity: true,
    marginMm: 10,
    headingSize: 22,
    bodySize: 9,
    shadeTableHeader: true,
    pickerLabel: 'Picker Name',
    signatureLabel: 'Sign',
  },
};

export async function loadSlipTemplates(signal?: AbortSignal): Promise<SlipTemplates> {
  const response = await authedFetch('/api/settings/slip-templates', { signal });
  if (!response.ok) throw ApiError.from(response, await response.json().catch(() => undefined));
  return (await response.json()) as SlipTemplates;
}

export async function saveSlipTemplate(kind: SlipKind, template: SlipTemplate): Promise<SlipTemplate> {
  const response = await authedFetch(`/api/settings/slip-templates/${kind}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(template),
  });
  if (!response.ok) throw ApiError.from(response, await response.json().catch(() => undefined));
  return (await response.json()) as SlipTemplate;
}
